import { Component, OnDestroy, OnInit } from '@angular/core';

import { MaterialModalService } from '@shared/material-modal/material-modal.service';

import { MobileGlobalSearchModalContentComponent } from './mobile-global-search-modal-content.component';

@Component({
  selector: 'mojo-mobile-global-search-modal',
  template: ``
})
export class MobileGlobalSearchModalComponent implements OnInit, OnDestroy {
  constructor(private materialModalService: MaterialModalService) {}

  ngOnInit() {
    this.materialModalService.open(MobileGlobalSearchModalContentComponent);
  }

  ngOnDestroy() {
    this.materialModalService.close();
  }
}
